import { DependencyList, useEffect } from 'react';
import {
    DialogProps,
    useDialog,
    useSimpleDialog,
} from '../../../hooks/useDialog';
import { TenantModel } from '../../../models/TenantModel';
import { DialogBox } from '../../atomic/dialog';
import { useGet } from '../../../hooks/useApi';
import { resendPassword, userApi } from '../../../APIs/userApi';
import { Loading } from '../../atomic/effects';
import React from 'react';
import { UserModel } from '../../../models/UserModel';
import { Button } from '../../atomic/buttons';

export const useTenantAdminUserDialog = ({}, deps: DependencyList) =>
    useSimpleDialog(
        AdminUserDialog,
        (options) => ({
            options,
            async onCommit() {},
            onError: (error) => error.message || '削除に失敗しました',
        }),
        deps
    );

export type AdminUserDialogProps = DialogProps<{ tenant: TenantModel }, void>;
export const AdminUserDialog = (props: AdminUserDialogProps) => {
    const { options, ...rest } = props;
    const { tenant } = options;
    const [adminUsers, setAdminUsers] = React.useState<UserModel[] | undefined>(
        undefined
    );
    const [sendedUserIds, setSendedUserIds] = React.useState<string[]>([]);

    const [message, setMessage] = React.useState<String>('');

    const { data: users } = useGet(userApi.get.tenantUsers(tenant.tenantId));

    useEffect(() => {
        if (users) {
            if (users.data.length) {
                setAdminUsers(
                    users.data.filter((user) => user.role === 'Admin')
                );
                setSendedUserIds(
                    users.data
                        .filter(
                            (user) =>
                                user.userStatus !== 'FORCE_CHANGE_PASSWORD'
                        )
                        .map((user) => user.userId)
                );
            } else {
                setAdminUsers([]);
            }
        }
    }, [users]);

    if (!adminUsers) {
        return <Loading />;
    }

    return (
        <>
            <DialogBox
                className="admin-users app-main"
                title="管理ユーザ一覧"
                okText="閉じる"
                disabledCancel={true}
                {...rest}
            >
                <div className="inner">
                    {adminUsers && (
                        <ul className="admin-users">
                            {adminUsers.map((user) => {
                                return rowUser(
                                    user,
                                    setMessage,
                                    sendedUserIds,
                                    setSendedUserIds
                                );
                            })}
                        </ul>
                    )}
                </div>
            </DialogBox>
            {message.length > 0 && (
                <DialogBox
                    className="admin-users"
                    title="招待メール送信"
                    onOK={() => {
                        setMessage('');
                    }}
                    okText="OK"
                    disabledCancel={true}
                >
                    {message}
                </DialogBox>
            )}
        </>
    );
};

const rowUser = (
    user: UserModel,
    setMessage: React.Dispatch<React.SetStateAction<String>>,
    sendedUserIds: string[],
    setSendedUserIds: React.Dispatch<React.SetStateAction<string[]>>
) => {
    const onReSent = (userId: string) => {
        resendPassword(userId)
            .then((resp) => {
                setMessage('招待メールを再送しました');
            })
            .catch((err) => {
                setMessage('エラーが発生しました');
            })
            .finally(() => {});
    };

    return (
        <li className="admin-user" key={user.userId}>
            {user.email}
            {
                <Button
                    className="atomic btn secondary"
                    onClick={() => {
                        if (user.userStatus === 'FORCE_CHANGE_PASSWORD') {
                            setSendedUserIds((prevState) => {
                                return [...prevState, user.userId];
                            });
                            onReSent(user.userId);
                        }
                    }}
                    disabled={sendedUserIds.indexOf(user.userId) >= 0}
                >
                    招待再送
                </Button>
            }
        </li>
    );
};
